<template>
	<div v-if="contacts.length > 0" class="flex flex-col">
		<div v-for="contact in contacts" :key="contact.id" class="flex gap-5 py-2 flex-row items-center odd:bg-white even:bg-sky-50 px-5">
			<div class="flex flex-col flex-grow break-all">
				<div class="w-full flex font-medium flex-col">
					<Link :href="route('contacts.get', { contact: contact.id })" class="cursor-pointer">
						{{ contact.first_name }} {{ contact.last_name }}
						<span v-if="contact.targeted" class="rounded text-blue-500 p-1">
							<i class="fas fa-crosshairs"></i>
						</span>
					</Link>
					<p class="text-sm text-gray-400">
						{{ page.props.str.statuses.find((element) => element.id == contact.status)?.name }}
					</p>
				</div>
			</div>
			<div class="flex flex-col items-center text-xs">
				<div :title="formatDateLong(contact.updated_at)" class="text-right flex-nowrap whitespace-nowrap">
					{{ formatDateRelative(contact.updated_at) }}
				</div>
			</div>
		</div>
	</div>
	<ui-alert type="success" v-else>Aucun prospect en attente pour l'instant</ui-alert>
</template>

<script setup>
	import { Link, usePage } from '@inertiajs/vue3';
	import { DateTime } from 'luxon';

	const page = usePage();

	const props = defineProps({
		contacts: {
			type: Array,
			required: true,
			default: () => [],
		},
	});

	const formatDateRelative = (dateString) => {
		return DateTime.fromISO(dateString).toRelative({ style: 'short' });
	};

	const formatDateLong = (dateString) => {
		return DateTime.fromISO(dateString).toLocaleString(DateTime.DATETIME_SHORT);
	};
</script>
